module.exports = __webpack_public_path__ + "media/images/story/icon/camera-4374759b2fcaec3a79cffdb696e241cc.svg";